"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Capability = {
  number: string;
  title: string;
  description: string;
  image: string;
};
const capabilities: Capability[] = [];
function CapabilityRow({
  capability,
  index
}: {
  capability: Capability;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const delay = index * 120;
  const isEven = index % 2 === 0;
  return <div data-index={index} ref={ref} style={{
    transitionDelay: isVisible ? `${delay}ms` : "0ms"
  }} className={`flex flex-col md:flex-row items-center gap-12 py-16 transition-all duration-[480ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${!isEven ? "md:flex-row-reverse" : ""}`}>
      <div className="w-full md:w-1/2">
        <p className="font-mono text-xs tracking-[0.06em] uppercase text-muted-foreground" style={{
        fontFamily: "var(--font-mono)"
      }}>
          {capability.number}
        </p>
        <h3 className="font-default font-medium mt-4" style={{
        fontSize: "clamp(1.25rem, 1.2vw + 0.75rem, 1.625rem)",
        letterSpacing: "-0.01em",
        lineHeight: 1.2,
        color: "#18334e"
      }}>
          {capability.title}
        </h3>
        <p className="font-default mt-4 max-w-md" style={{
        fontSize: "1rem",
        lineHeight: 1.6,
        color: "#80A2B3"
      }}>
          {capability.description}
        </p>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center">
        <div className="w-full max-w-[420px] h-[240px] md:h-[320px] overflow-hidden rounded-lg">
          <img src={capability.image} data-wvc-srcset={`${capability.image}-wvc-srcset`} data-wvc-sizes={`${capability.image}-wvc-sizes`} alt={`${capability.title} illustration`} className="w-full h-full object-cover grayscale-to-color-image" loading="lazy" decoding="async" />
        </div>
      </div>
    </div>;
}
export default function GrantAdministration() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}